import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/Sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/TopMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/ui/ContainerAside.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/product/slideshow/ProductSlideshow.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/product/stock-label/StockLabel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/products/product-grid/ProductGridItem.tsx");
